export default __webpack_public_path__ + "static/media/avatar-4.ea85b04d.jpg";